import { FC } from 'react';
import { Icon } from '../Icon';
import { Paragraph } from '../Paragraph';

type Color = 'dark' | 'darker' | 'light' | 'lighter';
type Variant = 'default' | 'small' | 'medium';
export type InfoTextProps = {
  text?: string;
  color: Color;
  variant: Variant;
};

const getColorClass = (colorInput: Color, variantInput: Variant) => {
  switch (colorInput) {
    case 'dark':
      if (variantInput !== 'default') {
        return 'text-gray-600';
      } else {
        return 'text-gray-700';
      }
    case 'darker':
      return 'text-gray-700';
    case 'light':
      if (variantInput !== 'default') {
        return 'text-gray-300';
      } else {
        return 'text-white';
      }
    case 'lighter':
      return 'text-white';
  }
};

export const InfoText: FC<InfoTextProps> = ({
  text = 'InfoText',
  color,
  variant,
}: InfoTextProps) => {
  return (
    <div className="flex space-x-2">
      <div className={`flex-shrink-0 w-6 ${getColorClass(color, variant)}`}>
        <Icon name={'InfoCircle'} />
      </div>
      <div>
        <Paragraph color={color} variant={variant}>
          {text}
        </Paragraph>
      </div>
    </div>
  );
};
